export const emptyValuesAsUndefined = (
  values: Record<string, unknown>
): Record<string, unknown> => {
  for (const propName in values) {
    if (values[propName] === '' || values[propName] === null) {
      delete values[propName];
    }
  }

  return values;
};
